export default __webpack_public_path__ + "static/media/birthday.d3a63139.png";